module.exports = __webpack_public_path__ + "img/money.45af08b4.svg";